import Backbone from 'backbone';

import Config from '../config';

import { promisify } from '../utils/promisify';





export { upload, dir, typeicons, priorityicons }




const _typeicons = Symbol( 'type-icons' ),
    _priorityicons = Symbol( 'priority-icons' );

function typeicons() {
    return _typeicons;
}

function priorityicons() {
    return _priorityicons;
}

function dir(filetypeFn) {
    switch(filetypeFn()) {
        case _typeicons: return 'type-icons';
        case _priorityicons: return 'priority-icons';
    }
}

function upload(binaryFile, url = '/files' /* also may be type */) {
    if (typeof url === 'function')
        url = `/files/${dir( url )}`;

    const data = new FormData();
    data.append( 'file', binaryFile );

    return promisify( Backbone.ajax( {
        url: Config.url( url ),
        data: data,
        contentType: false,
        processData: false,
        noLoader: true,
        method: 'POST'
    } ) );
}




// WEBPACK FOOTER //
// ./src/js/http/requests.js